module.exports = __webpack_public_path__ + "static/media/faq.0e08f537.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/information-center/faq.svg
// module id = 1213
// module chunks = 0